import { ComponentType, forwardRef, SVGProps } from 'react'

import { DesignIcon, ICONS, IconSystemColor, IconProps as RegistryIconProps } from '@/shared/lib/icons'

import styles from './Icon.module.scss'

type SvgIconProps = {
	icon: ComponentType<SVGProps<SVGSVGElement>>
	name?: never
	systemColor?: never
	title?: string
} & SVGProps<SVGSVGElement>

type NamedIconProps = {
	name: DesignIcon
	icon?: never
	systemColor?: IconSystemColor
} & RegistryIconProps

export type IconProps = SvgIconProps | NamedIconProps

export const Icon = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	if (!props.icon) {
		const { name, size, ...rest } = props as NamedIconProps
		// Avoid resolving inherited object properties such as "toString" as icon names.
		const IconComponent = Object.prototype.hasOwnProperty.call(ICONS, name) ? ICONS[name] : undefined

		if (!IconComponent) return null

		return <IconComponent ref={ref} size={size} {...rest} />
	}

	const { icon: SvgIcon, className = '', width = 24, height = 24, title, ...rest } = props as SvgIconProps

	return (
		<SvgIcon
			className={`${styles.icon} ${className}`}
			width={width}
			height={height}
			aria-hidden={title ? undefined : true}
			role={title ? 'img' : undefined}
			{...rest}>
			{title ? <title>{title}</title> : null}
		</SvgIcon>
	)
})
